import { render, staticRenderFns } from "./StudentLevelHistory.vue?vue&type=template&id=208eea74&scoped=true&"
import script from "./StudentLevelHistory.vue?vue&type=script&lang=js&"
export * from "./StudentLevelHistory.vue?vue&type=script&lang=js&"
import style0 from "./StudentLevelHistory.vue?vue&type=style&index=0&id=208eea74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208eea74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBtn,VCardText,VCardTitle,VChip,VIcon,VProgressCircular,VRow,VSimpleTable})
